(ns storrito.state.core
  (:require [reagent.core :as r]))

(defonce state
         (r/atom {}))

(defn cursor
  "Creates a Reagent cursor for the app state with the help of
  `reagent.core/cursor`. The `path` can be a single key(word) or a
   vector of keys."
  [path]
  (r/cursor state
            (if (sequential? path)
              path
              [path])))
